/**
 * Returns the global scrollFlagNamespace object, synced across plugins and router using a special symbol.
 * Namespace object is stored on window[Symbol.for('__nuxt_scroll_plugin_ns')] as a global, collision-resistant store.
 * Used to share scroll-related state (e.g., popstate/back-forward flags) between router and plugins.
 */
const scrollPluginNs = Symbol.for('__nuxt_scroll_plugin_ns');

export function getOrCreateScrollFlagNamespace(): Record<string, unknown> | undefined {
  if (typeof window === 'undefined') return undefined;
  if (!window[scrollPluginNs]) {
    window[scrollPluginNs] = {};
  }
  return window[scrollPluginNs] as Record<string, unknown>;
}

/**
 * Returns a string key for storing scroll position, unique to path, query, and hash.
 * Always based on the visible browser location (window.location.pathname + search + hash),
 * to ensure fine-grained restoration for all SPA navigation, including filter/query changes.
 */
export function getScrollStorageKey() {
  if (typeof window === 'undefined') return '';
  const { pathname, search, hash } = window.location;
  return encodeURIComponent(pathname + search + hash);
}
